(function () {
  'use strict';

  angular.module('sempraWebapp').factory('MyAccountViewModel', myAccountViewModelFactory);

  /** @ngInject */
  function myAccountViewModelFactory (sessionData) {
    function MyAccountViewModel () {
        var data = sessionData.getAll();
        this.username = data.username;
        this.firstName = data.firstName;
        this.lastName = data.lastName;
        this.userRole = (data.userRole.constructor === Array) ? data.userRole : data.userRole.split(',');
        this.oldPassword  = '';
        this.newPassword = '';
        this.newPasswordRepeat = '';
        this.newsLetter = (data.receiveEmailNotifications.toString() === 'true');

      init.call(this);
    }

    MyAccountViewModel.prototype.destroy = function () {
    };

    return MyAccountViewModel;

    function init () {

    }

  }
})();
